import React, { Component } from 'react';
import styles from './curiousBanner.module.scss';
import owl from '../../../assets/login-owl.svg';
import cx from 'classnames';
import { isNetquestClient, isPureProfileClient } from '../../../utils/clients';

interface Props {
  className?: string;
}

export class CuriousBanner extends Component<Props> {
  render(): React.ReactNode {
    if (isNetquestClient() || isPureProfileClient()) {
      return null;
    }
    const { className } = this.props;

    return (
      <div className={cx(styles.banner, className)}>
        <div className={styles.image}>
          <img src={owl} alt="#BeCurious" />
        </div>
        <div className={styles.header}>
          <h1>#BeCurious</h1>
        </div>
      </div>
    );
  }
}
